// Style sheets
require("./scss/main.scss");

// Custom JavaScript
require("./js/mobile-menu");
require("./js/customer-location-popup");
require("./js/single-product");
require("./js/sticky-header-bar");
require("./js/header");
require("./js/footer-klaviyo-form");
require("./js/newsletter-form-tracking");

// Elementor widgets
require("./js/elementor-widgets/image-slider");
require("./js/elementor-widgets/testimonials");
require("./js/elementor-widgets/image-textbox-slider");
require("./js/elementor-widgets/simple-slider");
require("./js/elementor-widgets/seo-accordion");
require("./js/elementor-widgets/header-bar-carousel");
require("./js/elementor-widgets/system-status");